export const SLICE = 'lps';

// getUserProfileInfo action types.
const GET_AUTHORIZED_LPS = `${SLICE}/GET_AUTHORIZED_LPS`;
export const GET_AUTHORIZED_LPS_REQUEST = `${GET_AUTHORIZED_LPS}_REQUEST`;
export const GET_AUTHORIZED_LPS_SUCCESS = `${GET_AUTHORIZED_LPS}_SUCCESS`;
export const GET_AUTHORIZED_LPS_FAILURE = `${GET_AUTHORIZED_LPS}_FAILURE`;

// getSelectedLp action types.
const GET_AUTHORIZED_LP_SELECTED = `${SLICE}/GET_AUTHORIZED_LP_SELECTED`;
export const GET_AUTHORIZED_LP_SELECTED_REQUEST = `${GET_AUTHORIZED_LP_SELECTED}_REQUEST`;
export const GET_AUTHORIZED_LP_SELECTED_SUCCESS = `${GET_AUTHORIZED_LP_SELECTED}_SUCCESS`;
export const GET_AUTHORIZED_LP_SELECTED_FAILURE = `${GET_AUTHORIZED_LP_SELECTED}_FAILURE`;

// getAuthorizedEntities action types.
const GET_AUTHORIZED_ENTITIES = `${SLICE}/GET_AUTHORIZED_ENTITIES`;
export const GET_AUTHORIZED_ENTITIES_REQUEST = `${GET_AUTHORIZED_ENTITIES}_REQUEST`;
export const GET_AUTHORIZED_ENTITIES_SUCCESS = `${GET_AUTHORIZED_ENTITIES}_SUCCESS`;
export const GET_AUTHORIZED_ENTITIES_FAILURE = `${GET_AUTHORIZED_ENTITIES}_FAILURE`;

// setLPPickerInput action type.
export const SET_LP_PICKER_INPUT = `${SLICE}/SET_LP_PICKER_INPUT`;

